import { render, staticRenderFns } from "./DataManagementList.vue?vue&type=template&id=78fc3653&scoped=true&"
import script from "./DataManagementList.vue?vue&type=script&lang=js&"
export * from "./DataManagementList.vue?vue&type=script&lang=js&"
import style0 from "./DataManagementList.vue?vue&type=style&index=0&id=78fc3653&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fc3653",
  null
  
)

export default component.exports